module.exports = __webpack_public_path__ + "static/media/government.bd2a9a10.svg";